import './interactions_view.js.coffee'
Customer.Ticket ||= {}

class Customer.Ticket.WhatsappInteractionsView extends Customer.Ticket.InteractionsView

  initialize: (@options = {}) ->
    super(@options)

  _createInteractionView: (interaction) ->
    new Customer.Ticket.WhatsappInteractionView(
      model: interaction,
      interactionsView: @,
      responseTemplates: @data.responseTemplates
      socialAccounts: @options.socialAccounts
      interactionVisualizationDefault: @options.interaction_visualization_default
      privateInteractionOnPublicContent: interaction.privateInteractionOnPublicContent
    )
